import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React, { useState } from "react";
import SchemaFieldImport from "react-jsonschema-form/lib/components/fields/SchemaField";
import { fixImport } from "mibaby-common/util/fixImport";

// Idk why this happens only here
import { jsx as _jsx } from "react/jsx-runtime";
var SchemaFieldBase = fixImport(SchemaFieldImport);
export function SchemaField(_ref) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    touched = _useState2[0],
    setTouched = _useState2[1];
  var showErrors = props.registry.formContext.showErrors;
  if (!showErrors && !touched) {
    // Hide errors until touched or submitted
    var onBlur = props.onBlur;
    props.onBlur = function () {
      return setTouched(true), onBlur && onBlur.apply(void 0, arguments);
    };
    props.errorSchema = {
      __errors: []
    };
  }
  return /*#__PURE__*/_jsx(SchemaFieldBase, _objectSpread({}, props));
}
export default SchemaField;
//# sourceMappingURL=SchemaField.js.map